import { PrelevementVitesse } from '../../../domain/Shared/prelevement-vitesse';
import { ClasseVitesse } from '../../../domain/Shared/classe-vitesse';
import { Prelevement } from 'src/app/domain/Shared/prelevement';
import { EInterventionType } from 'src/app/domain/planning/enum/intervention-type';

export class PrelevementDialogModel {
    Prelevement: Prelevement = new Prelevement();
    PrelevementVitesse: PrelevementVitesse = new PrelevementVitesse();
    AvailableVitesse: ClasseVitesse[] = [];
    IsCreation: boolean;
    IsForMGCE: boolean;
    MainSubstratType: number;
    InterventionType: EInterventionType
}